import { useQuery } from '@tanstack/react-query';
import { getCreatorQualitySignal } from '../api/creatorQualitySignals';
import type { CreatorSignalQualityResponse } from '../types/organizer';

export interface CreatorQualityData {
    qualitySignalData: CreatorSignalQualityResponse | undefined;
    isLoading: boolean;
    error: Error | null;
}

export const useCreatorQuality = (organizerId: string): CreatorQualityData => {
    const qualityQuery = useQuery<CreatorSignalQualityResponse, Error>(
        ['creatorQualitySignal', organizerId],
        () => getCreatorQualitySignal(organizerId),
        {
            enabled: !!organizerId,
            staleTime: 5 * 60 * 1000,
            cacheTime: 10 * 60 * 1000,
            retry: 2,
            retryDelay: (attemptIndex) =>
                Math.min(1000 * 2 ** attemptIndex, 30000),
        },
    );

    return {
        qualitySignalData: qualityQuery.data,
        isLoading: qualityQuery.isLoading,
        error: qualityQuery.error ?? null,
    };
};
